import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const defaultSrc = {
	default : '/images/default-photo.png',
	avatar  : '/images/default-avatar.png',
};

// When an image throws a 404, replace it with the generic src
document.addEventListener('error', (e) => {
	if (
		e.target.nodeName.toLowerCase() === 'img'
		&& (e.target.src !== defaultSrc[e.target.attributes['img-type'].value] || e.target.src !== defaultSrc.default)
	) {
	// eslint-disable-next-line no-param-reassign
		e.target.src = e.target.attributes['img-type'].value ? defaultSrc[e.target.attributes['img-type'].value] : defaultSrc.default;
	}
}, true);

/**
 * Renders an image that implements lazyloading, skeleton placeholders, and
 * updates with fallback generic images when original src returns a 404.
 *
 * For null sources, if a fallback image type is specified, use that default
 * generic image. Otherwise show no image.
 *
 * Requires lazysizes to be loaded globally
 */
class Image extends PureComponent {
	render() {
		const {
			className,
			src,
			fallbackSrc,
			alt,
		} = this.props;
		return (
			<img
				className={classNames(className, 'lazyload')}
				data-src={(!src && fallbackSrc) ? defaultSrc[fallbackSrc] : src}
				src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
				img-type={fallbackSrc}
				alt={alt}
			/>
		);
	}
}

Image.propTypes = {
	src         : PropTypes.string,
	className   : PropTypes.string,
	fallbackSrc : PropTypes.string,
	alt         : PropTypes.string,
};

Image.defaultProps = {
	className   : '',
	src         : '',
	fallbackSrc : '',
	alt         : '',
};

export default Image;
